exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.screenfull-svg[data-v-29234bee] {\n  display: inline-block;\n  cursor: pointer;\n  fill: #5a5e66;\n  width: 20px;\n  height: 20px;\n  vertical-align: 10px;\n}\n", ""]);

// exports
